import { render, staticRenderFns } from "./CoCheckboxNumber.vue?vue&type=template&id=530e58dc&"
import script from "./CoCheckboxNumber.vue?vue&type=script&lang=ts&"
export * from "./CoCheckboxNumber.vue?vue&type=script&lang=ts&"
import style0 from "./CoCheckboxNumber.vue?vue&type=style&index=0&id=530e58dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports